<template>
  <div class="equipmentManagement-page">
    <div class="all-content-container">
      <el-tabs
        :tab-position="tabPosition"
        style="height: 200px"
        v-model="activeName2"
      >
        <el-tab-pane label="传感器" name="first">
          <sensorManagement></sensorManagement>
        </el-tab-pane>
        <el-tab-pane label="摄像头" name="second">
          <cameraManagement></cameraManagement>
        </el-tab-pane>
        <el-tab-pane label="控制设备" name="third">
          <controlManagement></controlManagement>
        </el-tab-pane>
        <el-tab-pane label="通信网关" name="fourth">
          <communicationManagement></communicationManagement>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import sensorManagement from "@/components/device/sensorManagement";
import cameraManagement from "@/components/device/cameraManagement";
import controlManagement from "@/components/device/controlManagement";
import communicationManagement from "@/components/device/communicationManagement";

export default {
  name: "equipmentManagement",
  props: {
    message: {
      type: String,
      default: "first",
    },
  },
  components: {
    sensorManagement,
    cameraManagement,
    controlManagement,
    communicationManagement,
  },
  data() {
    return {
      tabPosition: "left",
      activeName2: "first",
    };
  },
  created() {
    this.activeName2 = this.message;
    this.$forceUpdate();
  },
};
</script>
<style lang="scss">
@import "@/style/equipmentManagement.scss";
</style>